module.exports = __webpack_public_path__ + "static/media/image15.debe8607.JPG";